/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 * Written by Hendrik, December 28, 2025.
 */

import React from 'react';
import './Login.css'; // Reuse login styles for consistency

export default function PrivacyPolicy() {
    return (
        <div className="login-wrapper">
            <div className="login-card" style={{ maxWidth: '800px' }}>
                <div className="brand-section">
                    <h1>Privacy Policy</h1>
                    <p>Marksure - Staff Login Portal</p>
                </div>

                <div className="privacy-content" style={{ textAlign: 'left', lineHeight: '1.6' }}>
                    <h2>1. Introduction</h2>
                    <p>This Privacy Policy outlines how Marksure ("We", "Us", "Our Service") processes personal information. We provide a mark calculation and academic management tool for teachers.</p>

                    <h2>2. Information We Collect</h2>
                    <p>We collect and process the following personal information:</p>
                    <p><strong>Teacher Data:</strong> Names, email addresses, and login credentials for authentication.</p>
                    <p><strong>Student Data:</strong> Names, grades, subjects, and assessment marks entered by teachers.</p>
                    <p><strong>Source of Information:</strong> All data is provided directly by teachers using our service.</p>

                    <h2>3. Purpose of Processing</h2>
                    <p>We use this information solely to:</p>
                    <ul>
                        <li>Calculate and aggregate academic results.</li>
                        <li>Generate reports for teachers.</li>
                        <li>Maintain the security and integrity of the teacher portal.</li>
                        <li>Provide academic management tools and support.</li>
                    </ul>
                    <p><strong>Note:</strong> We do not use student data for marketing, profiling, or commercial sales.</p>

                    <h2>4. Data Security</h2>
                    <p>We implement reasonable technical and organizational measures to secure the integrity and confidentiality of personal information, including:</p>
                    <ul>
                        <li>Encrypted storage and transmission (SSL).</li>
                        <li>Strict access controls (Password protection and Role-Based Access).</li>
                        <li>Regular backups to prevent data loss.</li>
                    </ul>

                    <h2>5. Information Sharing</h2>
                    <p>We do not sell, trade, or transfer personal information to third parties. Data is only shared with authorized technical service providers (e.g., cloud hosting) bound by strict confidentiality agreements.</p>

                    <h2>6. Data Retention</h2>
                    <p>We retain teacher and student data only for as long as teachers actively use our service. Teachers may request data deletion at any time, and data will be securely destroyed upon account termination.</p>

                    <h2>7. Your Rights</h2>
                    <p>As the data controller:</p>
                    <ul>

                        <li><strong>Data Access:</strong> You have the right to access, correct, or delete your data at any time.</li>
                    </ul>

                    <h2>8. Contact Us</h2>
                    <p>For privacy queries or data requests contact us<br />
                    </p>

                    <p><em>Last updated: January 15, 2026</em></p>
                </div>

                <div className="login-footer">
                    <p style={{ fontSize: '0.9em', color: '#666', marginBottom: '10px', textAlign: 'center' }}>
                        Marksure is a privately owned productivity tool. It is NOT an official system of the Department of Basic Education or SASAMS. Users are responsible for verifying all data against official records.
                    </p>
                    <p><a href="/" className="privacy-link">← Back to Login</a></p>
                </div>
            </div>
        </div>
    );
}